import { observer } from "mobx-react-lite";
import { CleanUpActions } from "@/components/note/floating-actions/clean-up-actions";
import { MemCommonEditorStore } from "@/components/note/store/mem-common-editor-store";
import { useRef, useState } from "react";
import {
  MDSButton,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSIcon,
  MDSIconKind,
  MDSPopover,
} from "@/mds";
import styled from "@emotion/styled";

interface CleanUpIndicatorProps {
  editorStore: MemCommonEditorStore;
}

export const CleanUpIndicator = observer(({ editorStore }: CleanUpIndicatorProps) => {
  const [isOpen, setIsOpen] = useState(true);
  const ref = useRef<HTMLButtonElement>(null);
  return (
    <>
      <StyledButton
        ref={ref}
        variant={MDSButtonVariant.EmphasisLight}
        onClick={() => setIsOpen(isOpen => !isOpen)}
      >
        <MDSIcon kind={MDSIconKind.Cleanup} slot={MDSButtonSlotName.LeftIcon} />
        <span>Clean Up</span>
        <MDSIcon
          kind={isOpen ? MDSIconKind.AngleDown : MDSIconKind.AngleUp}
          slot={MDSButtonSlotName.RightIcon}
        />
      </StyledButton>
      {editorStore && (
        <MDSPopover
          styling={false}
          triggerRef={ref}
          isOpen={isOpen}
          onOpenChange={setIsOpen}
          isNonModal={true}
        >
          <CleanUpActions editorStore={editorStore} />
        </MDSPopover>
      )}
    </>
  );
});

const StyledButton = styled(MDSButton)`
  height: 32px;
`;
